import { render, staticRenderFns } from "./Res.vue?vue&type=template&id=5f54edd6&scoped=true&lang=pug"
import script from "./Res.vue?vue&type=script&lang=js"
export * from "./Res.vue?vue&type=script&lang=js"
import style0 from "./Res.vue?vue&type=style&index=0&id=5f54edd6&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54edd6",
  null
  
)

export default component.exports